
// const SERVER_URL = "http://localhost:9000/";
const SERVER_URL = "https://app.intractapp.in/";




const endpoints = {
	// AUTH ENDPOINTS
	obtainJWT: SERVER_URL + 'jauth/jwt/create/',
	refreshJWT: SERVER_URL + 'jauth/jwt/refresh/',
	getMyDetails: SERVER_URL + 'base/users/me/',
	getInstitutionDetails: SERVER_URL + 'base/institution/id/',
	getRoomFromSections: SERVER_URL + 'base/rooms/get/',

	// SUBJECT ENDPOINTS
	getSubjectsByRoom: SERVER_URL + 'subjects/room/',
	getFacultySubjects: SERVER_URL + 'subjects/faculty/',

	// TEST ENDPOINTS
	getAllTests: SERVER_URL + 'tests/api/tests/all/',
	getAllFacultyTests: SERVER_URL + 'tests/api/tests/faculty/all/',	
	getAllPreviousTests: SERVER_URL + 'tests/api/tests/all/previous/',
	getAllPreviousFacultyTests: SERVER_URL + 'tests/api/tests/faculty/previous/all/',	
	getTestDetails: SERVER_URL + 'tests/api/tests/details/',
	getTestQuestions: SERVER_URL + 'tests/api/tests/questions/all/',
	uploadQuestionDetails: SERVER_URL + 'tests/api/tests/questions/create/',
	deleteQuestion: SERVER_URL + 'tests/api/tests/questions/delete/',
	deleteTest: SERVER_URL + 'tests/api/tests/delete/',
	submitTest: SERVER_URL + 'tests/api/tests/submit/',
	createOrEditTest: SERVER_URL + 'tests/api/tests/create_or_edit/',
	getCheatersFromServer: SERVER_URL + 'tests/api/tests/cheatings/',
	getTestStatsFromServer: SERVER_URL + 'tests/api/tests/stats/',
	getStudentResultsFromServer: SERVER_URL + 'tests/api/tests/stats/student/result/',
	sendCheatingNotification: SERVER_URL + 'tests/api/tests/cheating/create/',
	getTestStudentDetails: SERVER_URL + 'tests/api/tests/user/details/',
	updateSubjectiveMarks: SERVER_URL + 'tests/api/tests/subjective/update/',
}

export default endpoints;

